<template>
  <div>
    <div style="display: none!important;">
      <electron-vue-printer
        ref="electronVuePrinter"
        :show="true"
        :options="options"
        :rotateType="rotateType"
        :silent="false"
      >
      </electron-vue-printer>
    </div>
    <!-- {{print}} -->
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Товар</th>
          <th>{{$t('Нарх')}} <input type="checkbox" v-model="price"></th>
          <th>{{$t('Cони')}} 
            <button style="float: right;" type="button" class="btn btn-primary" @click='Printer()'>
            <b-icon icon="printer"></b-icon>
          </button>
          <button style="float: right;" type="button" class="btn btn-success" @click='Clear()'>
            {{$t('Тозалаш')}}
            </button>
        </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in datas.prixod_table" :key="index">
          <td>
            {{item.product.extra_name}}
          </td>
          <td>
            {{item.chakana_price}}
          </td>
          <td>
            <input type="number" @input="item.count=parseInt(item.count)" v-model="item.count">
          </td>
        </tr>
      </tbody>
    </table>
    <div class="mybody" id="my-node">
      <span v-for="(item, index) in datas.prixod_table" :key="index">
        <div v-if="item.shtrix_kod!=''" v-for="n in item.count">
          <div class="page" v-if="price!=true">
          <center>{{item.product.extra_name}}</center>
          <barcode fontSize="30" width="3" height="110px" :value="item.shtrix_kod"></barcode>
          <center v-if="price==true" >{{item.chakana_price|numFormat0}} cўм</center>
        </div>
        <div class="page price" v-else>
          <center>{{item.product.extra_name}}</center>
          <div class="pricebarcode">
          <b class="pricetext">{{item.chakana_price|numFormat0}}</b>
            <div style="width: 80px !important;display: block;">
              <p>00</p><hr class="hr"><p>cўм</p>
            </div>
          </div>
            <barcode width="2" height="42px" :value="item.shtrix_kod"></barcode>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import VueBarcode from 'vue-barcode';
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import electronVuePrinter from "electron-vue-printer";
export default {
  name: "Print",
  components: { 'barcode': VueBarcode,electronVuePrinter, htmlToImage },
  data() {
    return {
      datas: [],
      mysklad: [],
      dataUrl:null,
      print:'false',
      printer: '',
      price:false,
      rotateType: 0,
      options: {
        offsetX: 0,
        offsetY: 0,
        imageWidth: 160,
      },
      qarz: 0
    };
  },
  created: function() {
    this.Data();
  },
 async updated(){
    if(this.print=='print'){
      this.$refs.electronVuePrinter.deviceNamePrint = this.printer.check_printer_name;
      await this.$refs.electronVuePrinter.print(this.dataUrl);
    }
  },
  methods: {
    Starprinting(data){
      if(data==true){
        // window.close();
      }
    },
    Data() {
      let self = this;
      axios
        .get("api/v1/prixod/id/" + self.$route.params.id)
        .then(function(response) {
          self.datas = response.data;
          self.Mysklad();
          self.Qarzdorlik();
        });
    },
    async Printer() {
      let self = this;
      var node = document.getElementsByClassName("page");
      console.log(node.length);
      await htmlToImage
        .toSvg(node[0])
        .then(function(dataUrl) {
          self.$refs.electronVuePrinter.print(dataUrl)
        })
        .catch(function(error) {
          console.error("oops, something went wrong!", error);
        });
    },
    Qarzdorlik() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/kontragent/total",
        data: {
          kontragent_id: self.datas.kontragent_id,
          sklad_id: self.datas.sklad_id,
          datetime: self.datas.created_at
        }
      }).then(function(response) {
        self.qarz = response.data.total;
        self.print=true;
      });
    },
    Mysklad() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/sklads/id/" + self.datas.sklad_id
      }).then(function(response) {
        self.mysklad = response.data;
      });
    }
  },
  watch: {
    "$store.state.changed": function() {
      if (this.$store.state.changed != null) {
        this.Ostatka(this.$store.state.selected_index);
        this.$store.state.changed = null;
      }
    }
  }
};
</script>
<style>
   .vue-barcode-element{
    width: 100%!important;
    height: 6vh;
  }
  .page center{
    line-height: 1;
    font-size: 8pt!important;
  }
  .page{
    page-break-after: always;
    page-break-inside: avoid;
    padding: 0!important;
  }
</style>
<style scoped>
#my-node {
  width: 113px;
}

h5 {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

ul {
  list-style: none;
  border-bottom: 1px dotted;
  text-align: left;
  padding: 0;
  margin: 0;
  font-size: 13px;
  color: black;
}
</style>
